// @ts-nocheck
import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createPublication } from "../../../features/publication";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const AddPublication = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [language, setLanguage] = useState("en");

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    photo: null,
  });

  const [imagePreview, setImagePreview] = useState(null);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0],
      }));
      setImagePreview(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    formDataFinal.append("language", language);
    formDataFinal.append("folder_name", "publication");
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(createPublication(formDataFinal))
      .then((resultAction) => {
        if (createPublication.rejected.match(resultAction)) {
          // This means it was a rejection, handle error
          // toast.error("An error occurred while creating the Publication.");
          console.error(resultAction.payload || resultAction.error);
        } else {
          navigate("/publication");
          toast.success("Publication created successfully!");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("An error occurred while creating the publication.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Publication
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Language Field */}
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px ",
                  fontWeight: "500",
                  lineHeight: "normal",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                <MenuItem style={{ marginBottom: "5px" }} value="en">
                  English
                </MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>

          {/* Title Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="title"
              placeholder="Enter the publication title"
              value={formData.title}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Description
              </SoftTypography>
            </SoftBox>
            <textarea
              name="description"
              placeholder="Enter the description"
              value={formData.description}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </SoftBox>

          {/* Icon Field */}
          <SoftBox mb={2}>
            <SoftBox >
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Icon
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept="image/*"
              name="photo"
              onChange={handleImageChange}
              style={{width: "100%", padding:'10px', border:'1px solid #ccc', borderRadius:'5px'  }}
            />
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                style={{ width: "150px", height: "150px", marginTop: "20px" }}
              />
            )}
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="final"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddPublication;
